<template>
  <div>
    <b-modal
      id="notification"
      v-model="showModal"
      :title="iTitle"
      centered
      ok-only
      @ok="onOkayHandler"
    >
      <div>{{ iText }}</div>
    </b-modal>
  </div>
</template>

<script>
import errorCodes from "../helper/errorCodes";
export default {
  name: "Notification",
  props: {
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    show: { type: Boolean, default: false },
    error: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      iTitle: "",
      iText: ""
    };
  },
  watch: {
    show: {
      handler: function(newVal) {
        this.showModal = newVal;
      },
      immediate: true
    },
    title: {
      handler: function(newVal) {
        this.iTitle = newVal;
      },
      immediate: true
    },
    text: {
      handler: function(newVal) {
        this.iText = newVal;
      },
      immediate: true
    },
    error: {
      handler: function(e) {
        if (
          typeof e.status !== "undefined" &&
          this.title === "" &&
          this.text === ""
        ) {
          if (e.status === 404) {
            this.iTitle = "Server nicht erreichbar";
            this.iText =
              "Der Server ist aktuell nicht erreichbar. Bitte probiere es zu einem späteren Zeitpunkt erneut.";
          } else if (e.status === 401) {
            let code = e.data.data.code;
            this.iTitle = "Bitte überprüfe deine Eingaben";
            this.iText = errorCodes[code];
          } else if (e.status === 400) {
            this.iTitle = "Oops!";
            this.iText = errorCodes[e.data.data.code];
          } else {
            this.iTitle = "Oops!";
            this.iText =
              "Da ist etwas schief gelaufen. Bitte probiere es erneut!";
          }
        } else if (this.title === "" && this.text === "") {
          this.iTitle = "Oops!";
          this.iText =
            "Da ist etwas schief gelaufen. Bitte probiere es erneut!";
        }
      },
      immediate: true
    }
  },
  methods: {
    onOkayHandler() {
      this.$emit("okay");
    }
  }
};
</script>

<style scoped></style>
